/**************************************************************************************************/
/** @import Helpers/Utils                                                                        **/
/**************************************************************************************************/
import { TypesHelper } from '@/Helpers/Utils/TypesHelper'

/**************************************************************************************************/
/** @export Class @name QRHelper                                                                 **/
/**************************************************************************************************/
export class QRHelper
{
	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public static encodeStorageAccessTotem(storageCode: string, storagePass?: string) : string
	{
		const storageCodePass        = `${ storageCode }:${ storagePass || '1234' }`
		const storageCodePassEncoded = TypesHelper.toStringBase64Encoded(storageCodePass)
		const storageCodePassObs     = `S1JFSVMyMDIyOg${ storageCodePassEncoded }`
		return TypesHelper.toStringReversed(storageCodePassObs)
	}
}